// This file has been generated. DO NOT EDIT.
/**
 * Apollo 3 no longer merges incoming data automatically. This means every object in operations must have id
 * Or we can explicitly declare types that we want to merge in this file.
 * https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
 * For arrays, we normally want the incoming array to replace the existing one
 * unless the incoming array is carrying updates so by default we replace it to avoid warnings in consoles
 * https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-arrays
 */
import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
    Query: {
        merge: true,

        fields: {
            applicants: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            brandProfiles: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            briefReferenceProjects: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            collaborationDeliveries: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            collaborationsForFreelancer: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            designLivePreviousDesigners: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            expertServices: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            myDesignServicesFeaturedProducts: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            productOptions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            products: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            recommendations: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            topProducts: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            workPreviews: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Mutation: { merge: true },
    BriefChatSession: {
        merge: true,

        fields: {
            messages: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BriefChatMessage: { merge: true },
    BriefChatResponse: { merge: true },
    BriefInferredState: { merge: true },
    Document: {
        merge: true,

        fields: {
            values: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BriefSchema: {
        merge: true,

        fields: {
            fields: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BriefFieldDefinition: { merge: true },
    BriefFieldValue: {
        merge: true,

        fields: {
            multiText: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            multiChoice: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            files: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BriefFile: { merge: true },
    MyDesignersResponse: {
        merge: true,

        fields: {
            designers: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    DesignerSummary: {
        merge: true,

        fields: {
            collaborations: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    DesignerCollaborationSummary: { merge: true },
    DesignLiveDesigner: { merge: true },
    GenerateAIRevisionResponse: {
        merge: true,

        fields: {
            previews: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    GenerateAIRevisionResponsePreview: { merge: true },
    SaveGeneratedRevisionResponse: { merge: true },
    GetOrCreateChatResponse: { merge: true },
    GetChatTokenResponse: { merge: true },
    GetCollaborationWorkItemsForUserResponse: {
        merge: true,

        fields: {
            workItems: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    CollaborationWorkItem: { merge: true },
    CollaborationListItem: { merge: true },
    Revisions: { merge: true },
    Appointment: { merge: true },
    GetCollaborationResponse: { merge: true },
    AdminOrderOverview: { merge: true },
    GetCollaborationForAdminResponse: { merge: true },
    RemediationData: { merge: true },
    LatestActivityTimes: { merge: true },
    CollaborationResponse: {
        merge: true,

        fields: {
            deliveryVersions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            participants: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Completion: { merge: true },
    CollaborationPermissions: { merge: true },
    DeliveryVersion: { merge: true },
    Delivery: {
        merge: true,

        fields: {
            variations: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    DeliveryVariation: {
        merge: true,

        fields: {
            surfaceViews: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    WorkEntity: {
        merge: true,

        fields: {
            views: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    WorkEntityMerchandising: { merge: true },
    WorkEntityProduct: { merge: true },
    WorkEntityDesign: { merge: true },
    WorkEntityDesignMetadata: { merge: true },
    SurfaceView: { merge: true },
    CollaborationParticipant: { merge: true },
    Collaboration: {
        merge: true,

        fields: {
            events: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    GetEventFeedResponse: {
        merge: true,

        fields: {
            events: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Event: { merge: true },
    CreateDeliveryContent: { merge: true },
    AppointmentContent: { merge: true },
    StartCollaborationContent: { merge: true },
    ApproveCollaborationContent: { merge: true },
    NotifyInactivityContent: { merge: true },
    RevisionRequest: {
        merge: true,

        fields: {
            variationComments: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            files: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            passingGeneratedCimdocs: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    DeliveryVariationHasPassingGeneratedCimdoc: { merge: true },
    DeliveryVariationSurfaceComment: { merge: true },
    SurfaceComment: { merge: true },
    RequestRevisionContent: { merge: true },
    CollaborationFile: { merge: true },
    CareforceBriefUrlResponse: { merge: true },
    GenericResponse: { merge: true },
    JoinResponse: { merge: true },
    CollaboratePrintProduct: { merge: true },
    DeliveryVariationAsset: { merge: true },
    DeliveryVariationBrandKit: { merge: true },
    CopyWorksResponse: {
        merge: true,

        fields: {
            newWorkIds: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    CheckCopyWorkPermissionResponse: { merge: true },
    CollaborationTask: { merge: true },
    GetOverdueTasksResponse: {
        merge: true,

        fields: {
            tasks: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    WorkItem: { merge: true },
    GetMyWorkListResponse: {
        merge: true,

        fields: {
            items: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    AvailableWorkItem: { merge: true },
    GetAvailableWorkResponse: {
        merge: true,

        fields: {
            items: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    TeamWorkItem: { merge: true },
    GetTeamWorkResponse: {
        merge: true,

        fields: {
            items: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ReleaseWorkResponse: {
        merge: true,

        fields: {
            released: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            failed: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ClaimWorkResponse: { merge: true },
    SetMessageResponseDismissedResponse: { merge: true },
    StructuredBriefValidationError: { merge: true },
    StructuredBriefFulfilment: { merge: true },
    StructuredBrief: {
        merge: true,

        fields: {
            designers: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            designersWithSource: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            errors: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            foreignKeys: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            requiresCertifications: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            dynamicFields: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            groups: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BriefConfig: {
        merge: true,

        fields: {
            requiresFacts: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BriefTenant: { merge: true },
    Group: { merge: true },
    DesignerWithSource: { merge: true },
    DisplayCriteria: { merge: true },
    Display: { merge: true },
    InputField: { keyFields: false, merge: true },
    TextAreaField: { keyFields: false, merge: true },
    SelectChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    MultiSelectChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            multiChoiceValues: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Variant: { merge: true },
    GridChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    MultiGridChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            multiGridChoiceValue: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PrintServiceOptionsField: { keyFields: false, merge: true },
    RadioChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    MultiChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            multiChoiceValue: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ChoiceOption: {
        merge: true,

        fields: {
            price: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            optionDetails: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    MultiInputField: {
        keyFields: false,
        merge: true,

        fields: {
            multiInputValue: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BudgetField: { keyFields: false, merge: true },
    DateField: { keyFields: false, merge: true },
    BooleanField: { keyFields: false, merge: true },
    FilesField: {
        keyFields: false,
        merge: true,

        fields: {
            filesValue: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            allowedFileTypes: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ClientConfiguredField: { keyFields: false, merge: true },
    WorkEntityField: { keyFields: false, merge: true },
    IntelligentStylesValue: {
        merge: true,

        fields: {
            designs: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    IntelligentStylesField: {
        keyFields: false,
        merge: true,

        fields: {
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    SquarespacePackageChoiceField: { keyFields: false, merge: true },
    LogoContestTierChoiceField: { keyFields: false, merge: true },
    ContestUpgradesChoiceField: {
        keyFields: false,
        merge: true,

        fields: {
            contestUpgradesChoiceValues: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            options: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    StructuredBriefFile: { merge: true },
    BriefDesign: {
        merge: true,

        fields: {
            adminTags: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    CreatorHit: {
        merge: true,

        fields: {
            certifications: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            categoriesWithValues: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            locales: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    CreatorDesign: { merge: true },
    ImageSources: { merge: true },
    DesignCategory: { merge: true },
    ExpertDesign: {
        merge: true,

        fields: {
            cropCoordinates: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            tools: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            tags: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            adminTags: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    CustomerReview: { merge: true },
    Upload: { merge: true },
    Images: {
        merge: true,

        fields: {
            uploads: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PinComment: { merge: true },
    RevisionInformation: { merge: true },
    MerchantData: { merge: true },
    AppointmentData: { merge: true },
    DeliverableView: { merge: true },
    DocRef: {
        merge: true,

        fields: {
            previewUrls: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    DocRefPreviewUrl: { merge: true },
    Link: { merge: true },
    PreviewInstructions: { merge: true },
    CategoryResponse: {
        merge: true,

        fields: {
            productGroups: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            popularProducts: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductGroups: {
        merge: true,

        fields: {
            products: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Product: { merge: true },
    Prices: { merge: true },
    DesignProductResponse: { merge: true },
    DesignProduct: {
        merge: true,

        fields: {
            services: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            categories: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    DesignService: { merge: true },
    PagingInfo: { merge: true },
    VPProductCategory: { merge: true },
    ProductConfigurator: {
        merge: true,

        fields: {
            productOptions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            customValues: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            compatibleOptions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductOption: {
        merge: true,

        fields: {
            values: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductOptionValue: { merge: true },
    CustomValue: {
        merge: true,

        fields: {
            ranges: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductOptionRange: { merge: true },
    CompatibleOptionsEntry: {
        merge: true,

        fields: {
            value: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ViewLinkImage: { merge: true },
    ViewLink: { merge: true },
    View: { merge: true },
    GetAllViewsResponse: {
        merge: true,

        fields: {
            views: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ContentModel: {
        merge: true,

        fields: {
            inclusions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            heroImages: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            faqs: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Inspiration: {
        merge: true,

        fields: {
            designs: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    InspirationDesign: { merge: true },
    ContentfulDesigner: { merge: true },
    SimpleLink: { merge: true },
    Inclusion: { merge: true },
    MerchandisingProductView: { merge: true },
    CloudinaryImage: { merge: true },
    FAQ: { merge: true },
    Overview: { merge: true },
    MultimediaComponent: { merge: true },
    WorkEntitiesResult: {
        merge: true,

        fields: {
            results: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    WorkEntitiesPagination: { merge: true },
    Money: { merge: true },
    ExpertDesigns: {
        merge: true,

        fields: {
            designs: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Opportunity: {
        merge: true,

        fields: {
            applicants: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Match: { merge: true },
    Applicant: {
        merge: true,

        fields: {
            featuredDesigns: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Job: { merge: true },
    MatchedApplication: { merge: true },
    JobBrief: { merge: true },
    JobProduct: {
        merge: true,

        fields: {
            requiredCertifications: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            categoryExperience: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    JobExperience: { merge: true },
    JobPermissions: { merge: true },
    JobFlags: { merge: true },
    Application: { merge: true },
    ApplicationData: {
        merge: true,

        fields: {
            portfolio: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PortfolioItem: { merge: true },
    JobEntity: { merge: true },
    Order: { merge: true },
    BrandProfiles: {
        merge: true,

        fields: {
            logos: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    BrandLogo: { merge: true },
    PricingResponse: {
        merge: true,

        fields: {
            productPrices: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PriceDetail: { merge: true },
    SelectionPricingResponse: {
        merge: true,

        fields: {
            pivotPrices: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PivotPrice: { merge: true },
    ProductPrice: { merge: true },
    ServiceProductPricingOutput: { merge: true },
    PrintProductPricingOutput: { merge: true },
    LocaleMpvId: { merge: true },
    ProductPackageImage: {
        merge: true,

        fields: {
            points: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductPackageHeaderVideo: { merge: true },
    ProductPackageDetails: { merge: true },
    PriceRange: { merge: true },
    Marketing: { merge: true },
    CategoryExperience: { merge: true },
    CimpressProductConfig: { merge: true },
    ProductFixedPriceProject: {
        merge: true,

        fields: {
            details: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            additionalDetails: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            requiredCertifications: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            categoryExperience: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            fulfilment: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    FixedPrice: {
        merge: true,

        fields: {
            amounts: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductCategory: {
        merge: true,

        fields: {
            children: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PrintProduct: { merge: true },
    ServiceProduct: {
        merge: true,

        fields: {
            properties: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ExpertServicePrice: { merge: true },
    PropertyValue: { merge: true },
    ExpertService: { merge: true },
    ExpertServiceAgreement: { merge: true },
    KeyStrValueInt: { merge: true },
    ProductOptions: {
        merge: true,

        fields: {
            values: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ProductAttributeKey: { merge: true },
    ProductAttributeValue: { merge: true },
    MyDesignServicesFeaturedProduct: { merge: true },
    Customer: { merge: true },
    Recommendation: { merge: true },
    Request: {
        merge: true,

        fields: {
            invitedDesigners: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    RequestFacts: {
        merge: true,

        fields: {
            legacyDownloads: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            invitedDesignerCanonicalIds: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            serviceProductOptions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            experiments: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    PricePaidInCents: { merge: true },
    OptionalFacts: { merge: true },
    PrintOutcome: { merge: true },
    PrintOptions: { merge: true },
    CustomerDocument: {
        merge: true,

        fields: {
            reportedIssues: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    RequestLegacyDownload: { merge: true },
    KeyValue: { merge: true },
    ListResponse: {
        merge: true,

        fields: {
            requests: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Dates: {
        merge: true,

        fields: {
            dates: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    AppointmentDate: { merge: true },
    Times: {
        merge: true,

        fields: {
            times: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Timeslot: { merge: true },
    Category: {
        merge: true,

        fields: {
            priceRange: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            children: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    OAuthProviderProfile: { merge: true },
    User: {
        merge: true,

        fields: {
            languages: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            certifications: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Locale: { merge: true },
    Profile: { merge: true },
    OrderWorkSubItemProject: { merge: true },
    ContextMessageAndActionsCompletedProject: {
        merge: true,

        fields: {
            actions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ContextMessageAndActionsLockedProject: {
        merge: true,

        fields: {
            actions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ContextMessageAndActionsStartedProject: {
        merge: true,

        fields: {
            actions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    ContextMessageAndActionsInvitedProject: {
        merge: true,

        fields: {
            actions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    OrderWorkItem: {
        merge: true,

        fields: {
            items: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    WorkItemCollaborator: { merge: true },
    WorkItemStage: { merge: true },
    WorkItemIcon: { merge: true },
    WorkItemAction: { merge: true },
    StandardWorkItem: {
        merge: true,

        fields: {
            featuredDesignerAvatars: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            collaborators: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
            actions: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    YourWorkItemsResult: {
        merge: true,

        fields: {
            items: {
                merge(_existing = [], incoming: any[]) {
                    return incoming;
                },
            },
        },
    },
    Project: { merge: true },
};
